import {createModel} from '@@/package/utils/ModelUtil';
import Model from '@@/package/mapper/Model';

export class CountryModel extends Model {
    constructor(
        public id: number = 0,
        public koreanName: string = "",
        public englishName: string = "",
        public japaneseName: string = "",
        public nationCode: string = "",

        public name: string = ""
    ) {
        super();
    }

    public static create(model: Partial<CountryModel>): CountryModel {
        return createModel<CountryModel>(CountryModel, {
            ...model
        });
    }
}
